import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";
import { SITE } from "../data/vpns";

export const Seo = ({ title, description, schema, type = "website" }) => {
  const { pathname } = useLocation();
  const canonical = `${SITE.url}${pathname === "/" ? "" : pathname}`;
  const ogImage = `${SITE.url}/og-image.jpg`;
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonical} />
      <meta property="og:site_name" content={SITE.name} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:locale" content="en_US" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={ogImage} />
      {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
    </Helmet>
  );
};

export const SITE_SCHEMA = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "Organization",
      "@id": `${SITE.url}/#organization`,
      name: SITE.name,
      url: SITE.url,
      logo: `${SITE.url}/og-image.jpg`,
      email: SITE.email,
    },
    {
      "@type": "WebSite",
      "@id": `${SITE.url}/#website`,
      url: SITE.url,
      name: SITE.name,
      publisher: { "@id": `${SITE.url}/#organization` },
    },
  ],
};

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const reviewSchema = (vpn, meta) => ({
  "@context": "https://schema.org",
  "@type": "Review",
  itemReviewed: { "@type": "SoftwareApplication", name: vpn.name, applicationCategory: "SecurityApplication", operatingSystem: "Windows, macOS, iOS, Android, Linux" },
  reviewRating: { "@type": "Rating", ratingValue: vpn.score, bestRating: "10" },
  author: { "@type": "Organization", name: SITE.name },
  name: meta.metaTitle,
  reviewBody: meta.verdictBox,
});

export const articleSchema = (post) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: post.title,
  description: post.metaDescription,
  datePublished: post.date,
  author: { "@type": "Organization", name: post.author },
  publisher: { "@type": "Organization", name: SITE.name },
});

export const breadcrumbSchema = (crumbs) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: crumbs.map((c, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: c.label,
    item: `${SITE.url}${c.to || ""}`,
  })),
});
